import React, { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SettingsSVG from '../../svgs/SettingsSVG';
import TablesSVG from '../../svgs/TablesSVG';
import ProfileSVG from '../../svgs/ProfileSVG';
import CalendarSVG from '../../svgs/CalendarSVG';
import NewRequestSVG from '../../svgs/NewRequestSVG';
import DashboardSVG from '../../svgs/DashboardSVG';
import CustomNavLink from './CustomNavLink';
import { FaArchive } from "react-icons/fa";

import { FaChartPie } from "react-icons/fa";
import { HiOutlineDocumentReport } from "react-icons/hi";

const AdminSidebarMenu: React.FC = () => {
    const location = useLocation();
    const { pathname } = location;
    
    return (
        <>
            <nav className="mt-5 py-4 px-4 lg:mt-9 lg:px-6">
                    
                    <div>
                    <h3 className="mb-4 ml-4 text-sm font-semibold text-bodydark2">
                        MENU
                    </h3>

                    <ul className="mb-6 flex flex-col gap-1.5">
                
                        <li>
                            <CustomNavLink navPath="/" navPathInclude="/" isAbsoluteDashboard={true}>
                                <DashboardSVG />
                                Dashboard
                            </CustomNavLink>
                        </li>
                        <li>
                            <CustomNavLink navPath="/admin/archived" navPathInclude="/admin/archived" isAbsoluteDashboard={false}>
                                <FaArchive  />
                                Archived List
                            </CustomNavLink>
                        </li>
                        <li>
                            <CustomNavLink navPath="/request" navPathInclude="/request" isAbsoluteDashboard={false}>
                                <NewRequestSVG />
                                My Request List
                            </CustomNavLink>                            
                        </li>                
                        {/* <li>
                            <CustomNavLink navPath="/profile" navPathInclude="profile" isAbsoluteDashboard={false}>
                                <ProfileSVG />
                                Profile
                            </CustomNavLink>                            
                        </li>                         */}
                        {/* <li>
                            <CustomNavLink navPath="/admin/slip-chart" navPathInclude="/admin/slip-chart" isAbsoluteDashboard={false}>
                                <FaChartPie />
                                Slip Chart
                            </CustomNavLink>                                                        
                        </li> */}
                        <li>
                            <CustomNavLink navPath="/admin/reports" navPathInclude="reports" isAbsoluteDashboard={false}>
                                <HiOutlineDocumentReport className='text-xl' />
                                Reports
                            </CustomNavLink>                                                        
                        </li>                          
                        <li>
                            <CustomNavLink navPath="/settings" navPathInclude="settings" isAbsoluteDashboard={false}>
                                <SettingsSVG />
                                Settings
                            </CustomNavLink>                                                        
                        </li>            
                    </ul>

                    </div>

                </nav>    
        </>        
    );
};

export default AdminSidebarMenu;